import {format as formatDate, formatIsoDuration} from "@otrl/ui/lib/date";

export function getHandoffUrl({
  bookingEngineUrl, 
  fare, 
  startDate, 
}) { 
  const params = {
    origin: fare.origin.nlc,
    destination: fare.destination.nlc,
    adults: fare.ticketType.isFlexi? 8 : (fare.tickets?.[0]?.adults ?? 1),
    children: fare.tickets?.[0]?.children ?? 0,
    route: fare.route.code,
    ticketType: fare.ticketType.code,
    smartTicketType: fare.smartTicketType?.code,
    isSeason: fare.ticketType.isSeason ? "true" : "false",
    isOpenReturn: fare.ticketType.isReturn ? "true" : "false",
    duration: fare.ticketType.isFlexi
      ? "FLEXI"
      : fare.duration,
    startDate: formatDate(startDate, "yyyy-MM-dd"),
    railcards: null,
  };


  const queryString = Object.entries(params)
    .filter(([key, val]) => Boolean(val))
    .map(([key, val]) => `${key}=${val}`)
    .join("&");

  const searchPath = '/hand-off/fare';

 

  const handOffUrl = `${bookingEngineUrl}${searchPath}?${queryString}`;

 
  return handOffUrl;
}
